var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFsRoundBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 386,
    height: 410,
    viewBox: "0 0 386 410",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lsmya",
    d: "M175 187.97c81.19 0 147 65.84 147 147.06S256.19 482.1 175 482.1 28 416.25 28 335.03s65.81-147.06 147-147.06z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "lsmyc",
    width: 2,
    height: 2,
    x: -1,
    y: -1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26 186h297v298H26z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lsmya"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lsmyb",
    width: 492.7,
    height: 546.2,
    x: -64,
    y: 96,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 15.7,
    dy: 68.2,
    in: "SourceGraphic",
    result: "FeOffset1059Out"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "FeOffset1059Out",
    result: "FeGaussianBlur1060Out",
    stdDeviation: "32 32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lsmyd",
    x1: 175,
    x2: 175,
    y1: 482.09,
    y2: 187.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#704ffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40a4f3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#lsmyb)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    strokeOpacity: 0.05,
    strokeWidth: 0,
    mask: "url(\"#lsmyc\")",
    xlinkHref: "#lsmya"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#080011",
    fillOpacity: 0.05,
    xlinkHref: "#lsmya"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#557ef8",
    xlinkHref: "#lsmya"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#lsmyd)",
    xlinkHref: "#lsmya"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsRoundBlue);
export default __webpack_public_path__ + "static/media/fs-round-blue.60a5693c30dbf0b9c3017d8ddcae0302.svg";
export { ForwardRef as ReactComponent };